import styled from 'styled-components';
import { ReactNode } from 'react';
import LS from "../styles/layoutStyled";
import CS from "../styles/componentStyled";
import { alarmModal1State, alarmModal1Text } from '../atom/ModalAtom';
import { useRecoilState } from 'recoil';
import { useEffect, useState } from "react";

interface AlarmModal2Props {
    children: ReactNode;
}

const AlarmModal2SizeDown = ( { children }: AlarmModal2Props ) => {
    const [alarmText, setAlarmText] = useRecoilState(alarmModal1Text);
    const [modalState, setModalState] = useRecoilState(alarmModal1State);

    useEffect(() => {
        if (alarmText) {
            setModalState(true);
        }
    }, [alarmText, setAlarmText, setModalState]);

    const closeModal = () => {
        setModalState(false);
    };

    return (
        <>
            <CS.ModalBg>
                <CS.ModalType2SizeDown>
                    {children}
                </CS.ModalType2SizeDown>
            </CS.ModalBg>
        </>
    );
}

export default AlarmModal2SizeDown;